import React, {useEffect, useState} from "react";
import DataHandler from "config/DataHandler";

const useSettings = () => {
    const [appId, setAppId] = useState(0);

    // gets appId through DataHandler
    useEffect(() => {
        const getAppId = async () => {
            const appIdRes = await DataHandler.matchAppId();
            setAppId(appIdRes);
        };

        getAppId();
    }, []);

    return {appId};
};

export default useSettings;